export default __webpack_public_path__ + "static/media/965.02b63850.png";